import _actions_change from './_actions/change.js'
import _getters_data_main from './_getters/data/main.js'
import _getters_data_documents from './_getters/data/documents.js'
import _mutations_set from './_mutations/set.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        set: _mutations_set,
    },
    getters:{
        data_documents: _getters_data_documents,
        data_main: _getters_data_main,
    },
    actions:{
        change: _actions_change,
    },
}